// Shared formatters & helpers
export const fmtMoney = (n, compact = true) => {
  if (n == null) return "$0";
  const abs = Math.abs(n);
  if (compact && abs >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (compact && abs >= 1_000) return `$${(n / 1_000).toFixed(1)}K`;
  return `$${Number(n).toLocaleString()}`;
};

export const fmtNum = (n) => (n == null ? "0" : Number(n).toLocaleString());

export const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((s) => s[0]?.toUpperCase()).join("");

export const timeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return d.toLocaleDateString();
};

export const avatarColor = (name = "") => {
  const colors = ["#7C3AED", "#3B82F6", "#06B6D4", "#10B981", "#A855F7", "#F59E0B", "#EF4444"];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return colors[Math.abs(h) % colors.length];
};
